import React, { useRef } from "react";

const Searchbar = ({ songList, setFilteredList }) => {
  const inputRef = useRef();
  const filterList = () => {
    setFilteredList(
      songList.filter((song) => {
        return song.songName.includes(inputRef.current.value);
      })
    );
  };
  return (
    <>
      <div className="container mb-3">
        <input
          type="text"
          className="form-control"
          id="searchbar"
          aria-describedby="search"
          placeholder="Search"
          ref={inputRef}
          onChange={filterList}
        ></input>
      </div>
    </>
  );
};

export default Searchbar;
